exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-a7f8d864] {\n  margin-bottom: 0.5rem !important;\n}\n.blue[data-v-a7f8d864] {\n  color: #2962ff;\n}\n.timestamp[data-v-a7f8d864] {\n  font-size: 11px;\n  color: grey;\n  margin-top: -12px;\n}\n.notification[data-v-a7f8d864]:hover {\n  background: #f4f4f4;\n  border-radius: 6px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a7f8d864","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotificationItem.vue
// module id = GvKA
// module chunks = 0